import { useCallback } from 'react';
import { ShareToolFormContainer, ShareToolTabLeftSection, ShareToolTabRightSection } from './ShareToolLayout';
import { ShareToolTabFooter } from './ShareToolTabFooter';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { standaloneTrackInteraction } from '../../usage-tracker/standaloneTrack';
import { ToolPreview } from './ToolPreview';
import { ShareToolCloseButton } from './ShareToolCloseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { setHref } from '../../utils/location';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CrmEmailShareTab = ({
  description,
  emailCommunicatorUrl,
  buttonLabel,
  previewComponent,
  previewScale
}) => {
  const handleWriteEmailButtonClick = useCallback(() => {
    standaloneTrackInteraction({
      action: 'click write manual email button'
    });
    setHref(emailCommunicatorUrl);
  }, [emailCommunicatorUrl]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ShareToolTabLeftSection, {
      children: /*#__PURE__*/_jsxs(ShareToolFormContainer, {
        children: [/*#__PURE__*/_jsx("p", {
          children: description
        }), /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: handleWriteEmailButtonClick,
          block: true,
          children: buttonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.emailTab.writeManualEmailButton.text"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(ShareToolTabRightSection, {
      children: /*#__PURE__*/_jsx(ToolPreview, {
        scale: previewScale,
        children: previewComponent
      })
    }), /*#__PURE__*/_jsx(ShareToolTabFooter, {
      children: /*#__PURE__*/_jsx(ShareToolCloseButton, {})
    })]
  });
};